export default "__VITE_ASSET__CpHqbCTy__"